import React from 'react';
import './slider-main-container.css';


const SliderMain = () => {
    return(
        <div className="slider-main">
            <section className="call-to-action-area bg-fixed" >
                <div className="container h-100">
                    <div className="row align-items-center h-100">
                        <div className="col-12">
                            <div className="cta-content text-center">
                                <h2 className="wow fadeInUp" data-wow-delay="300ms">Are you looking for a place to
                                    rent?</h2>
                                <h6 className="wow fadeInUp" data-wow-delay="400ms">Suspendisse dictum enim sit amet
                                    libero malesuada feugiat.</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
};
export default SliderMain;